import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAllAssets,
  fetchAssetsDetail,
  fetchHomeAssets,
  fetchPublicAssets,
  fetchUserDetail,
} from "../actions/assetAction";
import { resendOtp } from "../actions/authAction";

const initialState = {
  isLoading: false,
  isToggle: false,
  assetList: [],
  assetCategoryList: [],
  assetData: {},
  relatedAssetList: [],
  userData:{},
};

export const assetSlice = createSlice({
  name: "asset",
  initialState: initialState,
  reducers: {
    setIsToggle: (state, action) => {
      state.isToggle = action.payload;
    },
  },
  extraReducers: (builder) => {
    // fetch-all-assets
    builder.addCase(fetchAllAssets.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchAllAssets.fulfilled, (state, action) => {
      const { assets, categories } = action?.payload ?? {};
      state.assetList = assets || [];
      state.assetCategoryList = categories || [];
      state.isLoading = false;
    });
    builder.addCase(fetchAllAssets.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetch-all-assets
    builder.addCase(fetchAssetsDetail.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchAssetsDetail.fulfilled, (state, action) => {
      const { asset, relatedAssets } = action?.payload ?? {};
      state.assetData = asset || {};
      state.relatedAssetList = relatedAssets || [];
      state.isLoading = false;
    });
    builder.addCase(fetchAssetsDetail.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetch-all-assets
    builder.addCase(fetchUserDetail.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchUserDetail.fulfilled, (state, action) => {
      const { user } = action?.payload ?? {};
      state.userData = user || {};
      state.relatedAssetList = user?.Asset || [];
      state.isLoading = false;
    });
    builder.addCase(fetchUserDetail.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetch-public-assets
    builder.addCase(fetchPublicAssets.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchPublicAssets.fulfilled, (state, action) => {
      const { assets, categories } = action?.payload ?? {};
      state.assetList = assets || [];
      state.assetCategoryList = categories || [];
      state.isLoading = false;
    });
    builder.addCase(fetchPublicAssets.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetch-home-assets
    builder.addCase(fetchHomeAssets.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchHomeAssets.fulfilled, (state, action) => {
      const { assets, categories } = action?.payload ?? {};
      state.assetList = assets || [];
      state.assetCategoryList = categories || [];
      state.isLoading = false;
    });
    builder.addCase(fetchHomeAssets.rejected, (state, action) => {
      state.isLoading = false;
    });

    // resend-otp
    builder.addCase(resendOtp.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(resendOtp.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(resendOtp.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});

export const { setIsToggle } = assetSlice.actions;
export default assetSlice.reducer;
